import React from 'react';
import { motion } from 'framer-motion';

const ScrollReveal = ({
  children,
  delay = 0,
  y = 32,
  once = true,
  className,
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: '0px 0px -40px 0px', amount: 0.15 }}
    transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export default ScrollReveal;
